<template>
  <div class="pix-list-wrapper mb-3">
    <Aguarde :show="httpSend"></Aguarde>
    <div class="pix-toolbar">
      <div class="toolbar-left">
        <button type="button" @click="alterMarcarTodos()" class="btn-tool">
          <i class="bx bx-check-double"></i>
          <span v-show="!marcar_todos">Marcar Todos</span>
          <span v-show="marcar_todos">Desmarcar Todos</span>
        </button>
        <button type="button" @click="verificarPagamento()" class="btn-tool btn-tool-success">
          <i class="bx bx-analyse"></i> Verificar Pagamento
        </button>
      </div>
      <div class="toolbar-right">
        <button type="button" @click="listPixs()" class="btn-tool btn-tool-primary">
          <i class="bx bx-search"></i> Pesquisar
        </button>
      </div>
    </div>

    <!-- ════════════ RESUMO ════════════ -->
    <div class="pix-resumo">
      <div class="resumo-card">
        <span class="resumo-label">Total de Pix</span>
        <span class="resumo-valor">{{ pixs.length }}</span>
      </div>
      <div class="resumo-card">
        <span class="resumo-label">Valor Total</span>
        <span class="resumo-valor resumo-destaque">
          {{ valor_total | formatNumeroBr }}
        </span>
      </div>
    </div>

    <!-- ════════════ TABELA ════════════ -->
    <div class="pix-table">

      <!-- Header -->
      <div class="pix-header">
        <div class="col-check"></div>
        <div class="col-codigo">Cód. Pix</div>
        <div class="col-duam">DUAM</div>
        <div class="col-nome">Nome / Razão Social</div>
        <div class="col-valor">Valor</div>
        <div class="col-expiracao">Expiração</div>
        <div class="col-pagamento">Pagamento</div>
        <div class="col-status">Status</div>
      </div>

      <div>
        <ContextMenuRetornoPagamento :visible="contextMenu.visible" :x="contextMenu.x" :y="contextMenu.y" :item="contextMenu.item"  @close="closeContextMenu"/>
      </div>

      <!-- Linhas -->
      <template v-for="p in pixs">
        <div
            :key="p.pix_codigo"
            class="pix-row"
            :class="{ 'pix-row-erro': p.erro_processamento }" @contextmenu="openContextMenu($event, p)"
        >
          <!-- Checkbox -->
          <div class="col-check">
            <b-form-checkbox v-if="p.pix_status === 1"
                v-bind:id="'id_verificacao_pix' + p.pix_codigo"
                v-model="p.verificar"
                :unchecked-value="false"
                class="custom-checkbox custom-checkbox-outline custom-checkbox-primary"
            />
          </div>

          <!-- Código Pix -->
          <div class="col-codigo" data-label="Cód. Pix">
            <span class="pix-codigo">{{ p.pix_codigo.padStart(10, "0") }}</span>
          </div>

          <!-- DUAM -->
          <div class="col-duam" data-label="DUAM">
            <span class="duam-codigo">{{ p.dam_codigo }}</span>
          </div>

          <!-- Nome -->
          <div class="col-nome" data-label="Nome">
            <span class="nome-texto">{{ p.pes_nome }}</span>
          </div>

          <!-- Valor -->
          <div class="col-valor" data-label="Valor">
            <div class="valor-info">
              <span class="valor-total">{{ p.pix_valor | formatNumeroBr }}</span>
              <span v-if="p.bab_valor_pago" class="valor-pago">
                Pago: R$ {{ p.bab_valor_pago | formatNumeroBr }}
              </span>
            </div>
          </div>

          <!-- Expiração -->
          <div class="col-expiracao" data-label="Expiração">
            {{ p.expiracao | formatDateHora }}
          </div>

          <!-- Data Pagamento -->
          <div class="col-pagamento" data-label="Pagamento">
            <template v-if="p.bab_data_pagamento">
              {{ p.bab_data_pagamento | formatDate }}
            </template>
            <span v-else class="sem-valor">—</span>
          </div>

          <!-- Status -->
          <div class="col-status" data-label="Status">
            <span v-if="p.send_http" class="status-badge status-verificando">
              <i class="fas fa-sync fa-spin"></i> Verificando
            </span>
            <template v-else>
              <span v-if="p.pix_status === 1" class="status-badge status-aguardando">Aguardando</span>
              <span v-if="p.pix_status === 5" class="status-badge status-cancelado">Cancelado</span>
              <span v-if="p.pix_status === 6" class="status-badge status-cancelado">Cancel. Sistema</span>
              <span v-if="p.pix_status === 9" class="status-badge status-pago">Pago</span>
            </template>
          </div>
        </div>

        <!-- Erro inline -->
        <div v-if="p.erro_processamento" :key="'erro-' + p.pix_codigo" class="pix-erro-row">
          <div v-if="p.msg_erro_processamento === 'Cancelado'" class="erro-msg erro-danger">
            <i class="mdi mdi-cancel"></i> Pix Cancelado
          </div>
          <div v-else class="erro-msg erro-info">
            <i class="mdi mdi-information-outline"></i> {{ p.msg_erro_processamento }}
          </div>
        </div>
      </template>

      <!-- Estado vazio -->
      <div v-if="!pixs.length || pixs.length < 1" class="pix-empty">
        <i class="bx bx-qr"></i>
        <p>Sem Pix</p>
      </div>
    </div>

  </div>
</template>

<script>
import Aguarde from "@/components/widgets/aguarde";
import {
  listRetornoPagamentoPix, verificaRetornoPagamentoPix
} from "@/api/admin/gestao/retorno_pagamento";
import {notifyAviso} from "@/helps/notificacao";
import ContextMenuRetornoPagamento from "@/router/views/admin/components/gestao/ContextMenuRetornoPagamento.vue";

export default {
  components: {
    ContextMenuRetornoPagamento,
    Aguarde
  },
  props: {
    filtro: {
      type: Object,
      require: true
    },
  },
  data() {
    return {
      contextMenu: {
        visible: false,
        x: 0,
        y: 0,
        item: null
      },
      httpSend: false,
      marcar_todos: true,
      pixs: []
    };
  },
  mounted() {
    window.addEventListener("click", this.closeContextMenu);
    window.addEventListener("scroll", this.closeContextMenu);
  },
  created() {
    this.listPixs()
  },
  beforeDestroy() {
    window.removeEventListener("click", this.closeContextMenu);
    window.removeEventListener("scroll", this.closeContextMenu);
  },
  computed: {
    valor_total: {
      get: function () {
        return this.pixs
            .map(p => Number(p.pix_valor))
            .reduce((sum, current) => sum + current, 0);
      }
    },
  },
  methods: {
    openContextMenu(event, item) {
      console.log(event)
      event.preventDefault();

      this.contextMenu = {
        visible: true,
        x: event.clientX,
        y: event.clientY,
        item: item
      };
    },
    closeContextMenu() {
      this.contextMenu.visible = false;
    },
    listPixs() {
      this.httpSend = true;
      listRetornoPagamentoPix(this.filtro).then(result => {
        if (result.status) {
          this.pixs = result.dados;
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    alterMarcarTodos() {
      this.marcar_todos = !this.marcar_todos;
      this.pixs.forEach(function (pix) {
        pix.verificar = this.marcar_todos;
      }, this);
    },
    verificarPagamento() {
      const pixs = this.pixs.filter((b) => b.verificar);
      if (pixs.length < 1) {
        notifyAviso("DattaNFSe", "Nenhum Pix selecionado")
        return
      }
      pixs.forEach(function (pix) {
        this.verifica(pix)
      }, this);
    },
    verifica(pix) {
      pix.send_http = true;
      verificaRetornoPagamentoPix(pix.pix_hash).then(result => {
        if (result.status) {
          pix.erro_processamento = false;
          pix.pix_status = result.dados.pix_codigo_status;
          if (result.dados.liquidado) {
            pix.bab_data_pagamento = result.dados.data_credito;
            pix.bab_valor_pago = result.dados.valor_pago;
          }
        } else {
          pix.erro_processamento = true;
          pix.msg_erro_processamento = result.mensagem;
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        pix.send_http = false;
      })
    }
  }
};
</script>

<style scoped>
/*
 * ═══════════════════════════════════════════════════
 *  VARIÁVEL GLOBAL DE FONTE
 *  Altere APENAS este valor para escalar tudo:
 * ═══════════════════════════════════════════════════
 */
.pix-list-wrapper {
  --pix-font-size: 12px;

  --fs-xs: calc(var(--pix-font-size) * 0.78);
  --fs-sm: calc(var(--pix-font-size) * 0.857);
  --fs-base: var(--pix-font-size);
  --fs-md: calc(var(--pix-font-size) * 1.07);
  --fs-lg: calc(var(--pix-font-size) * 1.28);
  --fs-xl: calc(var(--pix-font-size) * 1.57);
  --fs-icon: calc(var(--pix-font-size) * 1.7);

  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: var(--fs-base);
}

/* ═══════════ TOOLBAR ═══════════ */
.pix-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  gap: 8px;
  flex-wrap: wrap;
}

.toolbar-left,
.toolbar-right {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.btn-tool {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #374151;
  font-size: var(--fs-sm);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
}

.btn-tool:hover {
  background: #f3f4f6;
  border-color: #9ca3af;
}

.btn-tool i {
  font-size: var(--fs-base);
}

.btn-tool-success {
  background: #ecfdf5;
  border-color: #a7f3d0;
  color: #059669;
}

.btn-tool-success:hover {
  background: #d1fae5;
  border-color: #6ee7b7;
}

.btn-tool-primary {
  background: #eef2ff;
  border-color: #c7d2fe;
  color: #4338ca;
}

.btn-tool-primary:hover {
  background: #e0e7ff;
  border-color: #a5b4fc;
}

/* ═══════════ RESUMO ═══════════ */
.pix-resumo {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin-bottom: 10px;
}

.resumo-card {
  background: #fff;
  border: 1px solid #e8eaed;
  border-radius: 8px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.resumo-label {
  font-size: var(--fs-xs);
  font-weight: 500;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.resumo-valor {
  font-size: var(--fs-xl);
  font-weight: 700;
  color: #1f2937;
}

.resumo-destaque {
  color: #4f46e5;
}

.resumo-success {
  color: #059669;
}

.resumo-warning {
  color: #ea580c;
}

/* ═══════════ TABELA ═══════════ */
.pix-table {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e8eaed;
  overflow: hidden;
}

.pix-header {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: #fafbfc;
  border-bottom: 1px solid #e8eaed;
  font-size: var(--fs-xs);
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.pix-row {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px solid #f1f3f5;
  transition: background 0.15s ease;
}

.pix-row:hover {
  background: #f8f9fb;
}

.pix-row-erro {
  border-left: 3px solid #dc2626;
}

/* ── Colunas (flex proporcional) ── */
.col-check {
  flex: 0 0 32px;
  min-width: 32px;
  display: flex;
  align-items: center;
}

.col-codigo {
  flex: 0 1 90px;
  min-width: 70px;
}

.col-duam {
  flex: 0 1 55px;
  min-width: 40px;
}

.col-nome {
  flex: 2 1 140px;
  min-width: 100px;
  overflow: hidden;
}

.col-valor {
  flex: 1 1 100px;
  min-width: 80px;
}

.col-expiracao {
  flex: 1 1 100px;
  min-width: 75px;
}

.col-pagamento {
  flex: 0 1 85px;
  min-width: 65px;
}

.col-status {
  flex: 0 1 auto;
  min-width: 70px;
  max-width: 160px;
  overflow: hidden;
}

/* ── Código Pix ── */
.pix-codigo {
  font-weight: 600;
  font-size: var(--fs-base);
  color: #1f2937;
  font-variant-numeric: tabular-nums;
}

.duam-codigo {
  font-weight: 500;
  font-size: var(--fs-base);
  color: #4b5563;
}

/* ── Nome ── */
.nome-texto {
  font-weight: 600;
  font-size: var(--fs-base);
  color: #1f2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

/* ── Valor ── */
.valor-info {
  display: flex;
  flex-direction: column;
}

.valor-total {
  font-weight: 700;
  font-size: var(--fs-md);
  color: #1f2937;
  line-height: 1.2;
}

.valor-pago {
  font-size: var(--fs-xs);
  color: #10b981;
  font-weight: 600;
  margin-top: 2px;
}

.sem-valor {
  color: #d1d5db;
}

/* ── Status badges ── */
.status-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 20px;
  font-size: var(--fs-sm);
  font-weight: 600;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.status-aguardando {
  background: #fff7ed;
  color: #ea580c;
}

.status-pago {
  background: #ecfdf5;
  color: #059669;
}

.status-cancelado {
  background: #fef2f2;
  color: #dc2626;
}

.status-verificando {
  background: #f3f4f6;
  color: #4b5563;
}

.status-verificando i {
  font-size: var(--fs-xs);
  margin-right: 4px;
}

/* ── Erro inline ── */
.pix-erro-row {
  padding: 4px 12px 4px 44px;
  border-bottom: 1px solid #f1f3f5;
}

.erro-msg {
  font-size: var(--fs-xs);
  padding: 4px 10px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.erro-msg i {
  font-size: var(--fs-sm);
}

.erro-danger {
  background: #fef2f2;
  color: #dc2626;
}

.erro-info {
  background: #eff6ff;
  color: #2563eb;
}

/* ── Estado vazio ── */
.pix-empty {
  padding: 30px 12px;
  text-align: center;
  color: #9ca3af;
}

.pix-empty i {
  font-size: var(--fs-icon);
  margin-bottom: 8px;
  display: block;
}

.pix-empty p {
  font-size: var(--fs-base);
  margin: 0;
}

/* ═══════════ RESPONSIVO — TABLET (≤ 992px) ═══════════ */
@media (max-width: 992px) {
  .pix-resumo {
    grid-template-columns: repeat(2, 1fr);
    gap: 6px;
  }

  .pix-header {
    display: none;
  }

  .pix-row {
    flex-wrap: wrap;
    gap: 6px;
    padding: 10px;
    position: relative;
  }

  .pix-row [data-label]::before {
    content: attr(data-label);
    display: block;
    font-size: var(--fs-xs);
    font-weight: 600;
    color: #9ca3af;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    margin-bottom: 2px;
  }

  .col-check {
    position: absolute;
    top: 10px;
    left: 10px;
  }

  .col-codigo {
    flex: 0 0 auto;
    min-width: auto;
    padding-left: 32px;
  }

  .col-duam {
    flex: 0 0 auto;
    min-width: auto;
  }

  .col-nome {
    flex: 1 1 100%;
    min-width: 0;
  }

  .col-valor,
  .col-expiracao,
  .col-pagamento {
    flex: 0 0 calc(33.33% - 4px);
    min-width: auto;
  }

  .col-status {
    flex: 0 0 auto;
    min-width: auto;
    max-width: none;
    overflow: visible;
  }
}

/* ═══════════ RESPONSIVO — MOBILE (≤ 576px) ═══════════ */
@media (max-width: 576px) {
  .pix-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .toolbar-left,
  .toolbar-right {
    justify-content: stretch;
  }

  .btn-tool {
    flex: 1;
    justify-content: center;
    font-size: var(--fs-xs);
    padding: 6px 8px;
  }

  .pix-resumo {
    grid-template-columns: 1fr 1fr;
    gap: 6px;
  }

  .resumo-card {
    padding: 8px 10px;
  }

  .resumo-valor {
    font-size: var(--fs-lg);
  }

  .pix-row {
    padding: 8px 8px 8px 36px;
    gap: 6px;
  }

  .col-codigo {
    padding-left: 0;
  }

  .col-nome {
    flex: 1 1 100%;
    order: -1;
  }

  .col-valor,
  .col-expiracao,
  .col-pagamento {
    flex: 0 0 calc(50% - 3px);
  }
}
</style>